// RecipeRoll wordmark for the auth screens (terracotta variant, matching the
// app's accent). Served from public/ so it needs no bundler import.
export function AuthLogo() {
  return <img src="/logo.png" alt="RecipeRoll" className="h-14 mb-5 w-auto mx-auto block" />;
}
